export default "__VITE_ASSET__DHeYr2GZ__"